<template>
  <!-- 单条参与者编辑器 — 对齐旧系统 ParticipantSelect.aspx 的 10 种类型 + 关系/筛选 -->
  <div class="pe-row">
    <div class="pe-main">
      <select :value="model.sourceType" @change="onTypeChange" class="pe-type">
        <option value="submitter">提交人</option>
        <option value="user">用户</option>
        <option value="org">某组织</option>
        <option value="role">某角色</option>
        <option value="step">某一步处理人</option>
        <option value="org_leader">某部门所有领导</option>
        <option value="org_member">某部门所有成员</option>
        <option value="all_participant">所有流程参与者</option>
        <option value="everyone">所有人</option>
        <option value="custom">自定义</option>
      </select>

      <!-- 用户 -->
      <template v-if="model.sourceType==='user'">
        <div class="pe-pick" :class="{ placeholder: !model.userName }" @click="openPerson('user')">
          <span class="sel-name-text">{{ model.userName || '点击选择用户' }}</span>
          <span class="sel-code-text" v-if="model.userCode">{{ model.userCode }}</span>
        </div>
      </template>

      <!-- 某组织（含子角色/领导） -->
      <template v-else-if="model.sourceType==='org'">
        <div class="pe-pick" :class="{ placeholder: !model.orgName }" @click="openPerson('org')">
          <span class="sel-name-text">{{ model.orgName || '点击选择组织' }}</span>
          <span class="sel-code-text" v-if="model.orgCode">{{ model.orgCode }}</span>
        </div>
        <select v-model="model.orgSubType" @change="emitChange" class="pe-subtype">
          <option value="leader">领导</option>
          <option value="role">角色</option>
        </select>
        <select v-if="model.orgSubType==='role'" v-model="model.orgRoleGuid" @change="emitChange" class="pe-subtype">
          <option value="">-- 选角色 --</option>
          <option v-for="r in orgRoleList" :key="r.guid" :value="r.guid">{{ r.name }}</option>
        </select>
        <input v-if="model.orgSubType==='leader'" v-model="model.orgLeader" @input="emitChange" class="pe-input" placeholder="领导职位（如 经理）" />
      </template>

      <!-- 某角色 -->
      <template v-else-if="model.sourceType==='role'">
        <div class="pe-pick" :class="{ placeholder: !model.roleName }" @click="openPerson('role')">
          <span class="sel-name-text">{{ model.roleName || '点击选择角色' }}</span>
          <span class="sel-code-text" v-if="model.roleCode">{{ model.roleCode }}</span>
        </div>
        <select v-model="model.includeSubRole" @change="emitChange" class="pe-subtype" title="是否包含下级角色">
          <option value="0">不包含下级角色</option>
          <option value="1">包含下级角色</option>
        </select>
      </template>

      <!-- 某一步处理人 -->
      <template v-else-if="model.sourceType==='step'">
        <select v-model="model.stepNodeId" @change="emitChange" class="pe-input">
          <option value="">-- 选步骤 --</option>
          <option v-for="n in nodeOptions" :key="n.id" :value="n.id">{{ n.name }}</option>
        </select>
      </template>

      <!-- 某部门所有领导 -->
      <template v-else-if="model.sourceType==='org_leader'">
        <div class="pe-pick" :class="{ placeholder: !model.orgName }" @click="openPerson('org')">
          <span class="sel-name-text">{{ model.orgName || '点击选择部门' }}</span>
          <span class="sel-code-text" v-if="model.orgCode">{{ model.orgCode }}</span>
        </div>
        <input v-model="model.leaderPosition" @input="emitChange" class="pe-input" placeholder="领导职位（可空=全部领导）" />
        <select v-model="model.includeSubLeader" @change="emitChange" class="pe-subtype">
          <option value="0">不包含下级组织领导</option>
          <option value="1">包含下级组织领导</option>
        </select>
      </template>

      <!-- 某部门所有成员 -->
      <template v-else-if="model.sourceType==='org_member'">
        <div class="pe-pick" :class="{ placeholder: !model.orgName }" @click="openPerson('org')">
          <span class="sel-name-text">{{ model.orgName || '点击选择部门' }}</span>
          <span class="sel-code-text" v-if="model.orgCode">{{ model.orgCode }}</span>
        </div>
        <select v-model="model.includeSubMember" @change="emitChange" class="pe-subtype">
          <option value="0">不包含下级成员</option>
          <option value="1">包含下级成员</option>
        </select>
      </template>

      <!-- 表单字段：仅 handler 中存在（兼容旧数据） -->
      <template v-else-if="model.sourceType==='field'">
        <input v-model="model.fieldName" @input="emitChange" class="pe-input" placeholder="表单字段名" />
      </template>

      <!-- 自定义 -->
      <template v-else-if="model.sourceType==='custom'">
        <input v-model="model.customText" @input="emitChange" class="pe-input" placeholder="自定义表达式" />
      </template>
    </div>

    <!-- 关系或筛选 -->
    <div class="pe-relation">
      <label class="pe-cb-inline">
        <input type="checkbox" :checked="!!model.relation?.enabled" @change="onRelationToggle" />
        启用关系或筛选
      </label>
      <template v-if="model.relation?.enabled">
        <label class="pe-cb-inline">
          <input type="checkbox" v-model="model.relation.includeSuperior" @change="emitChange" />
          包含上级部门
        </label>
        <label class="pe-cb-inline">
          <input type="checkbox" v-model="model.relation.byRank" @change="emitChange" />
          按职级大小跳过
        </label>
        <select v-model="model.relation.type" @change="emitChange" class="pe-subtype">
          <option value="direct_leader">直接领导</option>
          <option value="all_leaders">所有领导</option>
          <option value="position_leader">某职位领导</option>
          <option value="rank_leader">某职级领导</option>
        </select>
        <input v-if="model.relation.type==='position_leader'" v-model="model.relation.positionName" @input="emitChange" class="pe-input" placeholder="职位名称" />
        <input v-if="model.relation.type==='rank_leader'" v-model.number="model.relation.rankLevel" @input="emitChange" class="pe-input-sm" type="number" min="1" placeholder="职级" />
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'

const props = defineProps({
  /** v-model:model — 整个参与者对象（含 sourceType、用户/组织/角色 code&name、relation 等） */
  model: { type: Object, required: true },
  /** 可选的步骤下拉（用于 step 类型），传 [{ id, name }] */
  nodeOptions: { type: Array, default: () => [] },
  /** 触发上层 onChange 的回调 */
  onChange: { type: Function, default: null },
  /** 触发上层开窗选择的回调 */
  onPick: { type: Function, default: null }
})

// 某组织下属角色列表（按需懒加载）
const orgRoleList = ref([])

function emitChange() { props.onChange && props.onChange() }
function openPerson(type) { props.onPick && props.onPick(type) }

function onTypeChange(e) {
  const t = e.target.value
  // 切换类型时重置无关字段，避免脏数据
  props.model.sourceType = t
  if (t === 'user') {
    props.model.orgCode = ''; props.model.orgName = ''
    props.model.roleCode = ''; props.model.roleName = ''
  } else if (t === 'org' || t === 'org_leader' || t === 'org_member') {
    props.model.userCode = ''; props.model.userName = ''
    props.model.roleCode = ''; props.model.roleName = ''
  } else if (t === 'role') {
    props.model.userCode = ''; props.model.userName = ''
    props.model.orgCode = ''; props.model.orgName = ''
  } else {
    props.model.userCode = ''; props.model.userName = ''
    props.model.orgCode = ''; props.model.orgName = ''
    props.model.roleCode = ''; props.model.roleName = ''
  }
  emitChange()
}

function onRelationToggle(e) {
  const en = e.target.checked
  if (en && !props.model.relation) {
    props.model.relation = { enabled: true, includeSuperior: false, byRank: false, type: 'direct_leader', positionName: '', rankLevel: 1 }
  } else if (props.model.relation) {
    props.model.relation.enabled = en
  }
  emitChange()
}

// 切换类型为 org 时，自动确保子结构
watch(() => props.model.sourceType, (t) => {
  if (t === 'org' && props.model.orgSubType === undefined) props.model.orgSubType = 'leader'
  if (t === 'role' && props.model.includeSubRole === undefined) props.model.includeSubRole = '0'
  if (t === 'org_leader' && props.model.includeSubLeader === undefined) props.model.includeSubLeader = '0'
  if (t === 'org_member' && props.model.includeSubMember === undefined) props.model.includeSubMember = '0'
}, { immediate: true })
</script>

<style scoped>
.pe-row { display: flex; flex-direction: column; gap: 4px; padding: 6px 0; border-bottom: 1px dashed #f3f4f6; }
.pe-main { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.pe-relation { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; padding-left: 6px; font-size: 11px; color: #6b7280; }
.pe-type { padding: 4px 6px; border: 1px solid #d1d5db; border-radius: 4px; font-size: 12px; background: #fff; min-width: 130px; }
.pe-subtype { padding: 4px 6px; border: 1px solid #d1d5db; border-radius: 4px; font-size: 11px; background: #fff; min-width: 110px; }
.pe-input { flex: 1; min-width: 140px; border: 1px solid #d1d5db; border-radius: 4px; padding: 4px 8px; font-size: 12px; outline: none; }
.pe-input-sm { width: 80px; border: 1px solid #d1d5db; border-radius: 4px; padding: 4px 8px; font-size: 12px; outline: none; }
.pe-input:focus, .pe-type:focus, .pe-subtype:focus { border-color: #10b981; box-shadow: 0 0 0 2px rgba(16,185,129,.12); }
.pe-pick { flex: 1; min-width: 160px; padding: 4px 10px; border: 1px dashed #cbd5e1; border-radius: 4px; background: #f9fafb; cursor: pointer; font-size: 12px; display: flex; gap: 8px; align-items: center; }
.pe-pick.placeholder { color: #9ca3af; }
.pe-pick:hover { background: #ecfdf5; border-color: #10b981; }
.pe-cb-inline { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; cursor: pointer; }
.pe-cb-inline input { accent-color: #10b981; }
.sel-name-text { color: #1f2937; }
.sel-code-text { color: #6b7280; font-size: 11px; font-family: 'Consolas', monospace; background: #f3f4f6; padding: 1px 6px; border-radius: 3px; }
</style>